// Google Tag (gtag) types
interface IGtagConfig {
  send_page_view?: boolean;
  debug_mode?: boolean;
  [key: string]: any;
}
type TGtagArgs = ['js', Date] | ['config', string, IGtagConfig?] | ['event', string, any?] | ['set', any];

// Initialize dataLayer if it doesn't exist
if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
}

// Type-safe gtag function
function gtag(...args: TGtagArgs): void {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(...args);
  }
}

// GA4 client ID
function getGA4ClientIdFromCookie(): string | null {
  const match = document.cookie.match(/_ga=GA1\.1\.(\d+\.\d+)/);
  return match ? match[1] : null;
}

// Initialize Google Tag with measurement ID
function initializeGoogleTag(measurementId: string, env: string): void {
  if (env !== 'production') {
    return;
  }

  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Initialize gtag only if not already defined
  if (!window.gtag) {
    window.gtag = function (...args: any[]) {
      window.dataLayer.push(...args);
    };
  }

  // Set up gtag with current date
  const gtagFn = window.gtag || gtag;
  gtagFn('js', new Date());

  // Configure measurement ID
  gtagFn('config', measurementId, {
    send_page_view: true,
  });
}

// Initialize Meta Pixel
function initializeMetaPixel(pixelId: string, env: string): void {
  if (env !== 'production') {
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) {
      return;
    }
    n = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.call(n, ...args) : n.queue.push(args);
    };
    if (!f._fbq) {
      f._fbq = n;
    }
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  (window as any)._fbPixelId = pixelId;

  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
}

// Initialize TikTok Pixel
export function initializeTikTokPixel(pixelId: string, env: string): void {
  if (env !== 'production') {
    return;
  }

  if (typeof window === 'undefined' || !pixelId) {
    return;
  }

  if (!window.webkit) {
    (window as any).webkit = { messageHandlers: {} };
  }

  // Обязательное условие, иначе events.js упадёт
  window.TiktokAnalyticsObject = 'ttq';
  window.ttq = window.ttq || [];
  const ttq = window.ttq;

  if (!ttq._initialized) {
    ttq._initialized = true;

    ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
    ];
    ttq.setAndDefer = function (t: any, e: string) {
      t[e] = function (...args: any[]) {
        t.push([e, ...args]);
      };
    };
    for (const m of ttq.methods) {
      ttq.setAndDefer(ttq, m);
    }

    ttq.instance = function (id: string) {
      const inst = ttq._i[id] || {};
      for (const m of ttq.methods) {
        ttq.setAndDefer(inst, m);
      }
      return inst;
    };

    ttq.load = function (id: string, opts?: any) {
      const url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {};
      ttq._i[id] = {};
      ttq._i[id]._u = url;
      ttq._t = ttq._t || {};
      ttq._t[id] = Date.now();
      ttq._o = ttq._o || {};
      ttq._o[id] = opts || {};

      const script = document.createElement('script');
      script.async = true;
      script.src = `${url}?sdkid=${id}&lib=ttq`;
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    };
  }

  ttq.load(pixelId);
  ttq.page();
}

const getGoogleMapsLink = (lat: string, lng: string): string => {
  return `http://www.google.com/maps/place/${lat},${lng}`;
};

export const ThirdPartyServicesHelper = {
  getGA4ClientIdFromCookie,
  initializeGoogleTag,
  getGoogleMapsLink,
  initializeMetaPixel,
  initializeTikTokPixel,
};
